/* eslint-disable */
export default {
  forward: 'Encaminhar',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
